import { useBreakpoints } from '../../bookings/util/useBreakpoints';
import { useExperiment } from '../../common/ExperimentContext/useExperiment';
import { HeNotification } from '../../common/components/HeNotification/HeNotification';
import { DentalSpecialtyMessageExperiment } from './DentalSpecialtyMessageExperiment';

export const DentalSpecialtyMessage = () => {
  const isMobile = useBreakpoints().Small;
  const { data } = useExperiment(DentalSpecialtyMessageExperiment(isMobile));

  if (!data || isMobile) return null;

  return (
    <HeNotification hasIcon title={data.title}>
      {data.body}
    </HeNotification>
  );
};
